import { useEffect, useState } from 'react'

import { emitSpeakingOnMute } from 'helpers/events'
import { isObjectEmpty } from 'helpers/object'
import useInterval from 'hooks/useInterval/useInterval'

//webkitAudioContext is used for safari
/*reference taken from
    https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
    https://github.com/otalk/hark*/
const AudioContext = window.AudioContext || window.webkitAudioContext
const CHECK_ON_MUTE_INTERVAL = 300
const HIDE_MUTE_NOTICE_TIMEOUT = 5000
let audioContext

function initializeAnalyser(stream) {
    //ensuring that only one instance of audio context is running
    audioContext = audioContext || new AudioContext()
    const audioSource = audioContext.createMediaStreamSource(stream)

    const analyser = audioContext.createAnalyser()
    /*It's basically an average between the current buffer and the last buffer the 
        AnalyserNode processed, and results in a much smoother set of value changes over 
        time.*/
    analyser.smoothingTimeConstant = 0.1
    /*The fftSize property of the AnalyserNode interface is an 
        unsigned long value and represents the window size in samples 
        that is used when performing a Fast Fourier Transform (FFT) to 
        get frequency domain data.*/

    analyser.fftSize = 512

    audioSource.connect(analyser)
    return analyser
}

function getMaxVolume(analyser, fftBins) {
    var maxVolume = -Infinity
    analyser.getFloatFrequencyData(fftBins)
    for (var i = 0, fftBinsLength = fftBins.length; i < fftBinsLength; i++) {
        if (fftBins[i] > maxVolume && fftBins[i] < 0) {
            maxVolume = fftBins[i]
        }
    }

    return maxVolume
}

let timeoutId = null

const useSpeakingOnMute = isAudioEnabled => {
    const [analyser, setAnalyser] = useState(null)
    const [fftBins, setFftBins] = useState(null)

    useInterval(
        () => {
            if (analyser && fftBins) {
                var currentVolume = getMaxVolume(analyser, fftBins)
                //kept the threshold to -30 can be changed
                const speakingOnMute = !isAudioEnabled && currentVolume > -30
                if (speakingOnMute) {
                    emitSpeakingOnMute(true)
                } else {
                    if (!timeoutId) {
                        // TODO: Should create a useTimeout hook to take care of auto-clearing (just like useInterval)
                        timeoutId = setTimeout(() => {
                            emitSpeakingOnMute(false)
                            timeoutId = null
                        }, HIDE_MUTE_NOTICE_TIMEOUT)
                    }
                }
            }
        },
        isAudioEnabled ? null : CHECK_ON_MUTE_INTERVAL
    )

    useEffect(() => {
        if (isAudioEnabled) {
            emitSpeakingOnMute(false)
            timeoutId && clearTimeout(timeoutId)
            timeoutId = null
            return
        }
        let tempAnalyser
        let tempFftBins
        navigator.mediaDevices
            .getUserMedia({ audio: true, video: false })
            .then(function(stream) {
                tempAnalyser = initializeAnalyser(stream)
                tempFftBins = new Float32Array(tempAnalyser.frequencyBinCount)
                setAnalyser(tempAnalyser)
                setFftBins(tempFftBins)
            })
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
        }
    }, [isAudioEnabled])
}

export default useSpeakingOnMute
